<template lang="html">

  <a class="option-table column-center" :descargando="descargando" @click="descargar"
    :title="$t('descargar_resultados_calificacion')">
    <i class="column row-between ais">
      <download-doc></download-doc>
    </i>
    <span>{{ $t('descargar_resultados_calificacion') }}</span>
  </a>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import downloadDoc from '@/components/parts/icons/download-doc';

export default {
  name: 'descarga-resultados',
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      anioAcademico: 'getAnioAcademico'
    }),
    esNoTutoradas: function () {
      //el servicio a llamar depende del listado en el que estemos
      let vistas = ['no_tutorados', 'no_tutorados-historico'];
      return vistas.some(e => this.$route.name == e);
    }
  },
  methods: {
    ...mapActions(['requestUrlZipResultadosEncuestas']),
    descargar() {

      if (this.descargando) {
        return;
      }

      this.descargando = true;

      this.requestUrlZipResultadosEncuestas({
        noTutoradas: this.esNoTutoradas,
        idAnioAcademico: this.anioAcademico
      }).then(url => {
        this.descargando = false;
        (!!url) ? this.abrirZip(url) : null;
      }).catch(() => {
        this.descargando = false;
      });
    },
    abrirZip(url) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  components: {
    'download-doc': downloadDoc
  },
  data() {
    return {
      descargando: false
    }
  }
}
</script>

<style scoped lang="scss">
.option-table {
  text-transform: uppercase;
  font-size: 9px;
  line-height: 11px;
  text-align: center;
  padding: 0 10px;
  position: relative;
  //ancho fijo: es el hueco que se le reserva al buscador de la tabla
  width: 145px;
  flex-shrink: 0;
  cursor: pointer;

  &[descargando] {
    opacity: 0.5;
    pointer-events: none;
  }
}

.column {
  //la caja contiene al icono entero para que no se solape con la etiqueta,
  //y la etiqueta arranca a la misma altura que en el resto de botones
  width: 40px;
  height: 40px;
  position: relative;
  margin-bottom: 0;

  svg {
    width: 27px;
    height: 30px;
    object-fit: contain;
    object-position: top center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/descarga-resultados.vue